import { userNewsApi } from '@/api/endpoints/usernews';
import type { NewsItem } from '@/types/api';

// Адаптер для NewsModal: возвращает ВСЕ непрочитанные новости пользователя
// через GET /usernews (UserNewsManager::unread() на беке). Без пагинации —
// бек отдаёт массив целиком.
//
// Раньше использовали siteApi.news(1) — это был неправильный выбор:
// /site/news — публичный список с пагинацией pageSize=5 хардкод, в модалке
// показывал максимум 5 новостей. Теперь модалка совпадает с легаси-флоу.

export const getNews = async (): Promise<NewsItem[]> => {
  return userNewsApi.list();
};
